<template>
  <v-container class="pt-0" fluid>
    <Title :text="'All Products'" />
    <v-row
      v-for="department in departments"
      :key="department.category_id"
      class="background-color-white mb-6 mr-sm-0 px-6"
    >
      <v-col>
        <v-row align="center" justify="space-between">
          <v-col class="align-center d-flex">
            <div class="mr-2 side-nav-image-size">
              <Icon
                  :name="getDepartmentDisplayName(department.category_id).toLowerCase()"
                  :color="$vuetify.theme.themes.light.primary"
                  :title="getDepartmentDisplayName(department.category_id)"
                  :style="{height:'24px', width: '24px'}"
                  class="e2e-department-image"
              ></Icon>
            </div>
            <div class="font-size-lg">{{ getDepartmentDisplayName(department.category_id) }}</div>
          </v-col>
          <v-col class="text-right">
            <router-link
              :to="routeToDepartment(department)"
              class="align-center d-flex justify-end"
            >
              <div class="text-left e2e-department-viewmore">
                View more {{ getDepartmentDisplayName(department.category_id)  }}
              </div>
              <v-icon color="primary">mdi-chevron-right</v-icon>
            </router-link>
          </v-col>
        </v-row>
        <Menus v-if="department.category_id === 'Menu'" />
        <v-row v-if="department.category_id !== 'Menu'">
          <v-col
            v-for="product in adjustProductsLengthForBreakpoint(
              department.products
            )"
            class="position-relative"
            :key="product.upc"
            cols="12"
            sm="6"
            md="3"
            xl="2"
          >
            <Product :product="product" :size="'md'" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Menus from "@/components/Departments/Menus/Menus.vue";
import Product from "@/components/Product/index.vue";
import Title from "@/components/UI/Title.vue";
import Icon from '@/components/UI/Icon.vue'

export default {
  name: "Departments",
  components: {
    Icon,
    Menus,
    Product,
    Title,
  },
  computed: {
        ...mapGetters("departments", {
      getDepartmentDisplayName: 'getDepartmentDisplayName',
      getDepartmentSrc: 'getDepartmentSrc'
    }),
    ...mapState({
      departments: (state) => state.departments.data,
    }),
  },
  methods: {
    adjustProductsLengthForBreakpoint(products) {
      // 4 products are returned from API which fills an xl row (default)
      const end = {
        xs: 1,
        sm: 2,
        md: 4,
        lg: 4,
        xl: 6,
      };

      return products.slice(0, end[this.$vuetify.breakpoint.name]) || products;
    },
    routeToDepartment({
      category_id: departmentId,
      sub_categories: categories,
    }) {
      const departmentRoute = `/department/${departmentId}`;
      const departmentRouteWithoutCategories = `/department/${departmentId}/category/${departmentId}`;
      const menuRoute = "menu";

      return categories
        ? departmentId === "Menu"
          ? menuRoute
          : departmentRoute
        : departmentRouteWithoutCategories;
    }
  },
};
</script>
